import { getSize, splitChunks } from './utils';

export interface ReadonlyByteChunksView
{
    readonly size: number
    getBytes(): Iterator<number>
    getRawChunks(): Uint8Array[]
}

export default class ByteChunksView implements ReadonlyByteChunksView
{
    public readonly size: number;

    constructor(private readonly rawChunks: Uint8Array[])
    {
        this.size = getSize(this.rawChunks);
    }

    split(bytes: number): [ByteChunksView, ByteChunksView]
    {
        const [head, tail] = splitChunks(this.rawChunks, bytes);

        return [new ByteChunksView(head), new ByteChunksView(tail)];
    }

    getRawChunks(): Uint8Array[]
    {
        return this.rawChunks;
    }

    *getBytes(): Generator<number>
    {
        for (const rawChunk of this.rawChunks)
        {
            for (const byte of rawChunk)
            {
                yield byte;
            }
        }
    }

    setBytes(bytes: Uint8Array)
    {
        if (this.size !== bytes.byteLength)
        {
            throw new Error(
                `Resizing chunks is not supported (expected: ${this.size}, actual: ${bytes.byteLength})`,
            );
        }

        let offset = 0;

        for (const rawChunk of this.rawChunks)
        {
            rawChunk.set(bytes.subarray(offset, rawChunk.byteLength));
            offset += rawChunk.byteLength;
        }
    }
}
